import Button from "components/shared/button";
import { SvgDownload } from "components/svg";
import { FC } from "react";
import { downloadByUrl } from "utils/helpers";
import {
  downloadSchemaUrl,
  getBlobUrl,
  getDownloadButtonTitleKey,
} from "../helpers";

export const DownloadButtons: FC<{ solution?: Solution; disabled?: boolean }> = ({ solution, disabled }) => {
  return (
    <>
      {Object.entries(solution?.code_schema ?? {}).map(([key, codeSchema]) => (
        <Button
          key={key}
          data-background="white"
          accent
          data-height="40"
          text={getDownloadButtonTitleKey(key, true)}
          data-uppercase=""
          disabled={disabled}
          style={disabled ? { opacity: 0.5, filter: "grayscale(0.5)" } : undefined}
          onClick={async () =>
            downloadByUrl(
              await getBlobUrl(
                downloadSchemaUrl(
                  `${codeSchema}/${key}?fileDownloadName=${`${codeSchema}.${key}`}`
                )
              ),
              `${codeSchema}.${key}`
            )
          }
        >
          <icon data-svg-size="16">
            <SvgDownload />
          </icon>
        </Button>
      ))}
    </>
  );
};
